export const IPOS = "IPOS";
export const IPO_ERROR = "IPO_ERROR";
export const IPO_HIDE_ERROR = "IPO_HIDE_ERROR";
export const IPO_START_LOADER = "IPO_START_LOADER";
export const IPO_STOP_LOADER = "IPO_STOP_LOADER";
